enum EPriceType {
  ONE_PRICE = 'onePrice',
  VOLUME_PRICE = 'volumePricing',
  ONE_PRICE_EACH_CURRENCY = 'onePriceForEachCurrency',
  VOLUME_PRICE_AND_OPTIONS = 'volumePricingAndOptions',
  UNKNOWN = 'unknown',
}

export default EPriceType;
